import React from "react";

const Footer = () => (
  <footer className="bg-white border-t border-black/10 py-10 md:py-14" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
      <div className="font-display text-[13px] tracking-[0.32em] font-medium text-black">
        BELIEVE&nbsp;TEAM
      </div>
      <div className="text-xs text-zinc-500">
        © {new Date().getFullYear()} BELIEVE TEAM Insurance Group. Licensed in all states. All rights reserved.
      </div>
      <div className="flex items-center gap-6 text-xs text-zinc-500">
        <a href="#" className="link-underline hover:text-black" data-testid="footer-privacy">Privacy</a>
        <a href="#" className="link-underline hover:text-black" data-testid="footer-terms">Terms</a>
        <a href="#" className="link-underline hover:text-black" data-testid="footer-licenses">Licenses</a>
      </div>
    </div>
  </footer>
);

export default Footer;
